import { QRCodeSVG } from 'qrcode.react';
import React__default from 'react';
import { QRCodeContainer } from './styles.js';
import { Box, Typography } from '@mui/material';

var ZigQrCode = function (_a) {
    var _b = _a.url, url = _b === void 0 ? "www.zignaly.com" : _b, _c = _a.label, label = _c === void 0 ? "" : _c, id = _a.id, extraInfo = _a.extraInfo, className = _a.className, _d = _a.size, size = _d === void 0 ? 160 : _d, _e = _a.width, width = _e === void 0 ? 200 : _e, _f = _a.height, height = _f === void 0 ? 200 : _f;
    return (React__default.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "8px", className: className },
        label && (React__default.createElement(Typography, { variant: "h4", color: "neutral100", id: "".concat(id, "-label") }, label)),
        React__default.createElement(QRCodeContainer, { width: width, height: height },
            extraInfo && (React__default.createElement(Typography, { color: "neutral600", lineHeight: "13px", fontSize: "11px", marginTop: "-8px", marginBottom: "7px" }, extraInfo)),
            React__default.createElement(QRCodeSVG, { size: size, value: url, id: id }))));
};

export { ZigQrCode as default };
